import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogTitle from "@material-ui/core/DialogTitle"
import Divider from "@material-ui/core/Divider"
import Slide from "@material-ui/core/Slide"
import { makeStyles } from "@material-ui/core/styles"
import Typography from "@material-ui/core/Typography"
import ReceiptIcon from "@material-ui/icons/Receipt"
import React from "react"

import { Button } from "@material-ui/core"
import Retirada from "./Retirada"

const useStyles = makeStyles(theme => ({
    paper: {
        borderRadius: 16,
        boxShadow: theme.shadows[10],
        overflow: "hidden",
    },
    titleRoot: {
        display: "flex",
        alignItems: "center",
        padding: theme.spacing(2.5, 3),
    },
    titleIcon: {
        marginRight: theme.spacing(1.5),
        opacity: 0.95,
    },
    titleText: {
        letterSpacing: 0.2,
    },
    countChip: {
        marginLeft: theme.spacing(1.5),
        backgroundColor: "rgba(255,255,255,0.2)",
        color: "inherit",
        fontWeight: 600,
    },
    closeButton: {
        marginLeft: "auto",
        color: "inherit",
    },
    contentRoot: {
        padding: theme.spacing(2.5, 3),
        backgroundColor: theme.palette.background.paper,
    },
    list: {
        display: "grid",
        gridTemplateColumns: "1fr",
        gap: theme.spacing(1.5),
    },
    actionsRoot: {
        padding: theme.spacing(2),
        backgroundColor: theme.palette.background.default,
    },
    botaoFecharDialog: {
        backgroundColor: "red",
        color: "white",
        "&:hover": {
            backgroundColor: "#b30000",
        },
    },
}))

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />
})

export default function DialogAddRetirada(props) {
    const { retiradas = [], open, fullScreen, setOpen } = props
    const classes = useStyles()

    const handleClose = () => setOpen(false)

    const count = retiradas.length
    const titulo = `Há ${count} ${count === 1 ? "Alterações" : "Alteração"} no caixa`

    return (
        <Dialog
            fullScreen={fullScreen}
            open={open}
            onClose={handleClose}
            aria-labelledby="dialog-add-retirada-title"
            scroll="paper"
            fullWidth
            maxWidth="sm"
            TransitionComponent={Transition}
            PaperProps={{ className: classes.paper }}
            BackdropProps={{
                style: {
                    backgroundColor: "rgba(0,0,0,0.35)",
                    backdropFilter: "blur(2px)",
                },
            }}
        >
            <DialogTitle
                id="dialog-add-retirada-title"
                disableTypography
                className={classes.titleRoot}
            >
                <ReceiptIcon className={classes.titleIcon} />
                <Typography variant="h6" className={classes.titleText}>
                    Alterações do caixa
                </Typography>
            </DialogTitle>

            <DialogContent className={classes.contentRoot}>
                <Typography variant="body2" color="textSecondary" style={{ marginBottom: 12 }}>
                    {titulo}
                </Typography>
                <Divider style={{ marginBottom: 16 }} />
                <div className={classes.list}>
                    {retiradas.map((r, index) => (
                        <Retirada key={index} retirada={r} />
                    ))}
                </div>
            </DialogContent>

            <DialogActions className={classes.actionsRoot}>
                <Button
                    variant="outlined"
                    className={classes.botaoFecharDialog}
                    onClick={handleClose}
                >
                    Fechar
                </Button>
            </DialogActions>
        </Dialog>
    )
}
